import * as types from './actionTypes';  
import updateProspectusApi from '../api/updateProspectusApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doUpdateProspectus(request) {

  return {
    type: types.DO_UPDATE_PROSPECTUS, 
    request
  };
}

export function doUpdateProspectusRes(data) {  
  return {
    type: types.DO_UPDATE_PROSPECTUS_RES, 
    data
  };
}

export function updateProspectus(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      updateProspectusApi.doUpdateProspectus(request).then(data => {
        dispatch(doUpdateProspectusRes(data));
        dispatch(doUpdateProspectusRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}